import { CONSTS } from 'config/objectConst'

import { appDay } from './day'

const SIZES = ['B', 'KB', 'MB', 'GB', 'TB']

const formatSize = (bytes: number) => {
	let size = bytes

	let index = 0
	for (; size >= 1024 && index < SIZES.length - 1; index++) {
		size /= 1024
	}

	size = Math.round(size)
	return `${size} ${SIZES[index]}`
}

function generateName() {
	const now = appDay()
	const date = now.format('DD-MM-YYYY_HH-mm-ss')

	return `${CONSTS.PROJECT_NAME}Export_${date}.csv`
}

const workLink = document.createElement('a')

function saveFile(json: any, name: string) {
	const blob = new Blob([json], { type: 'octet/stream' })
	workLink.href = URL.createObjectURL(blob)
	workLink.download = name
	workLink.click()
}

export { formatSize, generateName, saveFile }
